<script lang="ts">
  export let imagepath: string;
  export let name: string;

  /** 이 컴포넌트의 인덱스 */
  export let thisIndex = 0;

  /** 현재 선택된 인덱스 */
  export let currentIndex = 0;

  function ev클릭() {
    currentIndex = thisIndex;
  }
</script>

<div class="productitem text-center" style="cursor:pointer;" on:click={ev클릭}>
  <img
    src="{imagepath}{thisIndex == currentIndex ? '_current' : ''}.png"
    alt="{name} 제품사진"
  />
  <div class:active={thisIndex == currentIndex} style="width: 100%;">
    {name}
  </div>
</div>

<style lang="scss">
  a {
    text-decoration: none;
  }
  .productitem {
    color: #000;
    font-size: 14px;
    position: relative;
    display: inline-block;
    width: 33%;
  }
  @media (min-width: 768px) {
    .productitem {
      width: 220px !important;
    }
  }
  .productitem:first-child::after {
    margin-top: 10%;
    height: 50%;
    width: 1px;
    background: #ddd;
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    display: block;
  }
  .productitem::before {
    margin-top: 10%;
    height: 50%;
    width: 1px;
    background: #ddd;
    position: absolute;
    right: 0;
    top: 0;
    content: "";
    display: block;
  }
  .productitem > img {
    width: 50%;
  }
  .active {
    color: #d5022b;
  }
</style>
